import { BrowserRouter } from 'react-router-dom'
import { AuthProvider, useAuth } from './lib/AuthContext'
import AuthPage from './pages/AuthPage'
import SetupProfile from './pages/SetupProfile'
import StaffroomApp from './pages/StaffroomApp'

function AppRoutes() {
  const { user, profile, loading } = useAuth()

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0D0D0D', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 48, color: '#E8622A', letterSpacing: '0.14em', marginBottom: 12 }}>EDIFYI</div>
        <p style={{ color: '#777', fontSize: 14, letterSpacing: '0.06em' }}>LOADING...</p>
      </div>
    </div>
  )

  if (!user) return <AuthPage />
  if (!profile?.role) return <SetupProfile />
  return <StaffroomApp />
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
